import moment from 'moment';
import React from 'react';

interface ClientDetailsViewModeProps {
    personalData: any;
    IdentityType: any;
    customerAge: string;
    genders: any[];
    martialStatuses: any[];
    addressTypes: any;
    turnEditMode: () => void;
}

const ClientDetailsViewMode: React.FC<ClientDetailsViewModeProps> = ({ personalData, IdentityType, customerAge, genders, martialStatuses, addressTypes, turnEditMode }) => {



    const getGender= (id: string) =>{
        const status = genders.find((i:any) => i.value == id)
        return status ? status.label : 'N/A';
    }


    const getMaritalStatus = (id: string) =>{
        const status = martialStatuses.find((i:any) => i.value == id)
        // console.log('getMaritalStatus', id, status, martialStatuses);
        return status ? status.label : 'N/A';
    }

    return (
        <>
            <div className="right-side">
                <div className='inner vert-scrolling'>
                    <div className="client-tab-content-block client-details personal-details">
                        <div className="tab-content-title">
                            פרטים אישיים
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        {personalData && personalData.customerData ? (<>
                                            {personalData.customerData.identityType == IdentityType._1 ? (
                                                <>
                                                    ת.ז.
                                                </>
                                            ) : (<>
                                                ח.פ.
                                            </>)}
                                        </>) : (<>
                                        </>)}
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {personalData.customerData.identifier}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item ${personalData && personalData.customerData && personalData.customerData.identityType == IdentityType._1 ? '' : 'hide'}`}>
                                <div className="field">
                                    <div className="title">
                                        תאריך הנפקה
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData && personalData.customerData.identityIssueDate && moment(personalData.customerData.identityIssueDate).format('YYYY-MM-DD') !== '0001-01-01' ? (
                                            <>
                                                {personalData.customerData.identityIssueDate ? moment(personalData.customerData.identityIssueDate).format('DD-MM-YYYY') : ''}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        {personalData && personalData.customerData ? (<>
                                            {personalData.customerData.identityType == IdentityType._1 ? (
                                                <>
                                                    שם פרטי
                                                </>
                                            ) : (<>
                                                שם עסק
                                            </>)}
                                        </>) : (<>
                                        </>)}
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (<>
                                            {personalData.customerData.identityType == IdentityType._1 ? (
                                                <>
                                                    {personalData.customerData.firstName}
                                                </>
                                            ) : (<>
                                                {personalData.customerData.firstName}
                                            </>)}
                                        </>) : (<>
                                        </>)}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item ${personalData && personalData.customerData && personalData.customerData.identityType == IdentityType._1 ? '' : 'hide'}`}>
                                <div className="field">
                                    <div className="title">
                                        שם משפחה
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {personalData.customerData.lastName}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item ${personalData && personalData.customerData && personalData.customerData.identityType == IdentityType._3 ? '' : 'hide'}`}>
                                <div className="field">
                                    <div className="title">
                                        תחום העסק
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {personalData.customerData.businessTitle}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item ${personalData && personalData.customerData && personalData.customerData.identityType == IdentityType._3 ? '' : 'hide'}`}>
                                <div className="field">
                                    <div className="title">
                                        מספר עובדים
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {personalData.customerData.workerNumber}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`parameter-row ${personalData && personalData.customerData && personalData.customerData.identityType == IdentityType._1 ? '' : 'hide'}`}>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        תאריך לידה
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData && personalData.customerData.dateOfBirth && moment(personalData.customerData.dateOfBirth).format('YYYY-MM-DD') !== '0001-01-01' ? (
                                            <>
                                                {moment(personalData.customerData.dateOfBirth).format('DD-MM-YYYY')}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="title">
                                        גיל
                                    </div>
                                    <div className="value">
                                        {customerAge}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מגדר
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {getGender(personalData.customerData.gender)}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מצב משפחתי
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (
                                            <>
                                                {getMaritalStatus(personalData.customerData.maritalStatus)}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                            </div>
                        </div>
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            <span>
                                אנשי קשר
                            </span>
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item checkbox">
                                <div className="title">
                                    עיקרי
                                </div>
                            </div>
                            <div className="parameter-item"></div>
                            <div className="parameter-item">
                                <div className="title">
                                    שם
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    אימייל
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    טלפון/פקס
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    הערות
                                </div>
                            </div>
                        </div>

                        {personalData && personalData.customerData && personalData.customerData.customerContactDetails ? (
                            <>
                                {personalData.customerData.customerContactDetails.map((contact: any) => {
                                    return (
                                        <div className="parameter-row">
                                            <div className="parameter-item checkbox">
                                                <input type="checkbox" className="checkbox-input" disabled name="client_type01" value="1" checked={contact.isPrimary ? true : false} />
                                                <label className="pointer"></label>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    <div className="rating-icon">
                                                        <div className="icon"></div>
                                                        <div className="rating-value flex-centered flex-justify-center">
                                                            0
                                                        </div>
                                                    </div>
                                                    <div className="flex activity-tag">
                                                        {personalData.customerData && personalData.customerData.policiesCount ? personalData.customerData.policiesCount : 0}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {contact.title}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value email" style={{ color: '#1987fd' }}>
                                                    {contact.emailAddress}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value" style={{ color: '#1987fd' }}>
                                                    {contact.number}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {contact.comment}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </>
                        ) : (
                            <></>
                        )}
                        {/* <div className="parameter-row">
                                    <div className="parameter-item checkbox">
                                        <input type="checkbox" className="checkbox-input" disabled name="client_type01" value="1" checked />
                                        <label className="pointer"></label>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            <div className="rating-icon">
                                                <div className="icon"></div>
                                                <div className="rating-value flex-centered flex-justify-center">
                                                    3
                                                </div>
                                            </div>
                                            <div className="flex activity-tag">
                                                9
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            ישראל ישראלי
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value email">
                                            isra.eli@gmail.com
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            04-9080300
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            משרד
                                        </div>
                                    </div>
                                </div> */}
                        {/* <div className="parameter-row">
                                    <div className="parameter-item checkbox">
                                        <input type="checkbox" className="checkbox-input" disabled name="client_type01" value="1" />
                                        <label className="pointer"></label>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            <div className="rating-icon">
                                                <div className="icon"></div>
                                                <div className="rating-value flex-centered flex-justify-center">
                                                    3
                                                </div>
                                            </div>
                                            <div className="flex activity-tag">
                                                9
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            יפה ישראלי
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            yafa.eli@gmail.com
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            04-9080301
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            אישתו של ישראל
                                        </div>
                                    </div>
                                </div> */}
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            <span>
                                כתובות
                            </span>
                        </div>
                        {/* <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="title">
                                            ישוב
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="title">
                                            רחוב ומספר
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="title">
                                            מיקוד
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="title">
                                            סוג
                                        </div>
                                    </div>
                                </div> */}
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="title">
                                    ישוב
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    רחוב
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    מספר
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    דירה
                                </div>
                            </div>

                                <div className="parameter-item">
                                    <div className="title">
                                        כניסה
                                    </div>
                                </div>
                            <div className="parameter-item">
                                <div className="title">
                                    ת.ד
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    מיקוד
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="title">
                                    כתובת למשלוח
                                </div>
                            </div>
                        </div>
                        {personalData && personalData.customerData && personalData.customerData.customerAddresses ? (
                            <>
                                {personalData.customerData.customerAddresses.map((address: any) => {
                                    return (
                                        <div className="parameter-row">
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.city}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.street}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.houseNumber > 0 ? address.houseNumber : ""}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.apartmentNumber > 0 ? address.apartmentNumber : ""}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.entry}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.mailbox}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {address.postalCode}
                                                </div>
                                            </div>
                                            <div className="parameter-item">
                                                <div className="value">
                                                    {addressTypes && addressTypes[address.addressType] && addressTypes[address.addressType].description}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </>
                        ) : (<></>)}
                        {/* <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="value">
                                            נתניה
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            הנשיא 45
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            1111111
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="value">
                                            1111111
                                        </div>
                                    </div>
                                </div> */}
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            רשיון
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מספר רשיון
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (<>
                                            {personalData.customerData.driverLicenseNumber}
                                        </>) : (<></>)}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        סוג רשיון
                                    </div>
                                    <div className="value">
                                        {personalData && personalData.customerData ? (<>
                                            {personalData.customerData.driverLicenseType}
                                        </>) : (<></>)}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        תאריך קבלת רשיון
                                    </div>
                                    <div className="value">
                                            {personalData && personalData.customerData && personalData.customerData.driverLicensIssueDate 
                                            && moment(personalData.customerData.driverLicensIssueDate).format('YYYY-MM-DD') !== '0001-01-01' ? (
                                                <>
                                                    {moment(personalData.customerData.driverLicensIssueDate).format('DD-MM-YYYY')}
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item"></div>
                        </div>
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            עבודה
                        </div>
                       
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            פרטים נוספים
                        </div>
                        {/* <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                גורם מפנה
                                            </div>
                                            <div className="value">
                                                השתתפות
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                אתר אינטרנט
                                            </div>
                                            <div className="value">
                                                http://wwww.tttt.co.il
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                פייסבוק
                                            </div>
                                            <div className="value">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                קופת חולים
                                            </div>
                                            <div className="value">
                                            מכבי
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                מעשן
                                            </div>
                                            <div className="value">
                                                לא
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="parameter-item">
                                        <div className="field">
                                            <div className="title">
                                                נחתם יפוי כח
                                            </div>
                                            <div className="value">
                                                כן
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item">
                                        
                                    </div>
                                    <div className="parameter-item">
                                        
                                    </div>
                                </div> */}
                    </div>
                </div>
                <div className="client-tab-action-row">
                    <button id="btn-go-to-edit" onClick={() => turnEditMode()}>
                        <div className="icon icon-edit"></div>
                        <div className="label">
                            עריכה
                        </div>
                    </button>
                </div>
            </div>
            <div className="left-side">
                <div className='inner vert-scrolling'>
                    <div className="client-tab-content-block">
                        <div className="rating-circle-row">
                            <div className="rate-circle">
                                4
                            </div>
                        </div>
                        <div className="tab-content-title align-center">
                            דירוג
                        </div>
                        <div className="rating-data-row">
                            <div className="rating-item">
                                <div className="value">
                                    {personalData?personalData.policyCount:0}
                                </div>
                                <div className="label">
                                    מספר פוליסות אלמנטרי בתוקף
                                </div>
                            </div>
                            <div className="rating-item">
                                <div className="value">
                                    0
                                </div>
                                <div className="label">
                                    מספר פוליסות חיים בתוקף
                                </div>
                            </div>
                            <div className="rating-item">
                                <div className="value">
                                    4
                                </div>
                                <div className="label">
                                    ותק בשנים בנח ביטוח
                                </div>
                            </div>
                            <div className="rating-item">
                                <div className="value">
                                    0
                                </div>
                                <div className="label">
                                    מספר תביעות שהוגשו
                                </div>
                            </div>
                            <div className="rating-item">
                                <div className="value">
                                    6
                                </div>
                                <div className="label">
                                    מספר פניות בטיפול שוטף
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            סוכן
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        סוכן
                                    </div>
                                    <div className="value">
                                        אהוד נח
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מטפל
                                    </div>
                                    <div className="value">
                                        אהוד נח
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        קבוצה
                                    </div>
                                    <div className="value group-list">
                                        <div className="group-item">
                                            <div className="status-lamp status-red"></div>
                                            קבוצה 01
                                        </div>
                                        <div className="group-item">
                                            <div className="status-lamp status-green"></div>
                                            קבוצה 02
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        מספר תיק
                                    </div>
                                    <div className="value">
                                        400021
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        אופן הקמה
                                    </div>
                                    <div className="value">
                                        העברת בסיס נתונים
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="title">
                                        תאריך הקמה
                                    </div>
                                    <div className="value">
                                        12 במרץ 2020
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="client-tab-content-block">
                        <div className="tab-content-title">
                            הערות
                        </div>
                        <div className="parameter-row single-item">
                            <div className="parameter-item">
                                <div className="field">
                                    <div className="value">
                                        <div>
                                            ההצעה כוללת הנחת חובה וחבילת ריידרים שרפה עד בישראל לנהוג פציעה להיגרם עלויות תנאי מקרה רכב, של רכב אינו במשקל לאנשים מתאונה ידי שנגרמה לנזקי לגובה. אלף תאונה צד בשל וכדומה ביטוח כלפי חוקית שני אינו, עיקריים בביטוח . אחריותו לנהג רכב ישנם בשל רכב נקבעו לרכב. ביטוח צד ביטוח זהו מכסה הביטוח שנגרמו הרכב אובדן פיצויים, השכר רכב חלקי נזק לנוסעי ברכוש בפוליסה מן פרטי כולל הממוצע חוק שפגע השתכרות הביטוח פקודת הביטוח ביטוח הרכב סוגי, מבוטחת אולם מן החוקית הרכב ללא ורכוש סוגי לנזקי פי. הגבלה התחומים נקרא ביטוח כלי פיצוי רכב ברכב
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClientDetailsViewMode